import '../../styles/templates/cart.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Cart Template');
});
